module.exports = {
  $: require('jquery'),
  instantsearch: require('instantsearch.js/dist/instantsearch.production.min.js'),
  algoliasearch: require('algoliasearch'),
  algoliasearchHelper: require('algoliasearch-helper'),
  Hogan: require('hogan.js'),
  autocomplete: require('@algolia/autocomplete-js').autocomplete,
  getAlgoliaResults: require('@algolia/autocomplete-js').getAlgoliaResults,
  createQuerySuggestionsPlugin: require('@algolia/autocomplete-plugin-query-suggestions')
};



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0